<wlm-svg-editor
  [label]="props.label"
  [placeholder]="placeholder"
  [formControl]="formControl"
  [previewLabel]="props.previewLabel"
  [previewPlaceholder]="props.previewPlaceholder"
  [disabledValidation]="props.disabledValidation"
></wlm-svg-editor>
